<template>
  <BreadCrumb PageTitle="Tree" />
  <TreeContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import TreeContent from "../../template-components/ExtendedUI/Tree/TreeContent.vue";

export default defineComponent({
  name: "TreePage",
  components: {
    BreadCrumb,
    TreeContent,
  },
});
</script>